import React from "react";
import classnames from "classnames";

import styles from "./RequestDataRow.module.scss";

interface Props {
  label: string;
  wideLabel?: boolean;
  children: React.ReactNode;
}

const RequestDataRow = (props: Props) => {
  const { label, wideLabel, children } = props;

  return (
    <div className={styles.row}>
      <span
        className={classnames(styles.label, {
          [styles.labelWide]: wideLabel,
        })}
      >
        {label}
      </span>
      <div className={styles.value}>{children}</div>
    </div>
  );
};

export default RequestDataRow;
